// extracted by mini-css-extract-plugin
export var details = "details-module--details--5ae39";
export var linkTitle = "details-module--linkTitle--4638d";
export var spanAnimated = "details-module--spanAnimated--e1b9c";